'use strict';
// the include for this file should be surrounded by a site preference check
function updateBuyNowButton() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.cswidget-external-js').length) {
            var widgets = $('.cswidget-external-js').toArray();
            widgets.forEach(function (item) {
                var currentProductId = $(item).data('pid');
                if (currentProductId && (currentProductId.toString() === response.data.product.id)) {
                    $(item).addClass('show');
                    $(item).removeClass('hide');
                } else if(!$(item).hasClass('hide') || $(item).hasClass('show')){
                    $(item).removeClass('show');
                    $(item).addClass('hide');
                }
            });
        }
    });
}
module.exports = function () {
    let features = JSON.parse(document.querySelector('body').dataset.features);
    if (features && features.enableOverrideBuyNowURL && features.enableOverrideBuyNowURL) {
        updateBuyNowButton();
    }
};